<template>
  <div class="container">
    <div class="container-fluid">
      <div class="row">
        <div @click="slide = 0" class="col-4 fedsightBlueBackground whiteText">
          <h2 class="carouselHeader">Strategy</h2>
        </div>
        <div @click="slide = 1" class="col-4 fedsightGreenBackground whiteText">
          <h2 class="carouselHeader">Development</h2>
        </div>
        <div @click="slide = 2" class="col-4 fedsightYellowBackground">
          <h2 class="carouselHeader">Operations</h2>
        </div>
      </div>
    </div>
    <div class="container-fluid relative">
      <div class="row triangleSection">
        <div v-if="slide == 0" class="col-4 d-flex justify-content-center">
          <div class="triangle-down-blue"></div>
        </div>
        <div
          v-else-if="slide == 1"
          class="col-4 d-flex justify-content-center m-auto"
        >
          <div class="triangle-down-green"></div>
        </div>
        <div
          v-else-if="slide == 2"
          class="col-4 d-flex justify-content-center ml-auto"
        >
          <div class="triangle-down-yellow"></div>
        </div>
      </div>
    </div>

    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="5000"
      indicators
      background="#ababab"
      img-width="1024"
      img-height="350"
      style="text-shadow: 1px 1px 2px #333"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Slide 1 -->
      <b-carousel-slide
        caption=""
        text-tag="div"
        text-html="
        <p class='slideText'>
          Create integrated, data-driven approaches to comprehensively address challenges and transform the organization.
        </p>
        "
        :img-src="images[0]"
      ></b-carousel-slide>

      <!-- Slide 2 -->
      <b-carousel-slide
        caption=""
        text-tag="div"
        text-html="
        <p class='slideText'>
          Design and execute holistic solutions that optimize your core business functions.
        </p>
        "
        :img-src="images[1]"
      >
      </b-carousel-slide>

      <!-- Slide 3 -->
      <b-carousel-slide
        class="slide3"
        caption=""
        text-tag="div"
        text-html="
        <p class='slideText'>
          Deliver efficient and effective support across your organization to enhance performance and minimize risk.
        </p>
        "
        :img-src="images[2]"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
/* eslint-disable */
import stratImg from "@/assets/strategy-medium.jpg";
import devImg from "@/assets/development-medium.jpg";
import opsImg from "@/assets/operations-medium.jpg";
export default {
  name: "Carousel",
  data() {
    return {
      slide: 0,
      show: true,
      sliding: null,
      images: [stratImg, devImg, opsImg],
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
      //console.log(slide)
    },
    onSlideEnd(slide) {
      this.sliding = false;
      //console.log(slide)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.carouselHeader {
  padding: 2rem 0rem;
  cursor: pointer;
  font-size: 2.5rem !important;
}
.carousel-item {
  height: 100%;
  max-height: 35rem;
}
.carousel-item > img {
  height: 100%;
}
.triangle-down-blue {
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-top: 30px solid #132631;
}
.triangle-down-green {
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-top: 30px solid #579c5f;
}
.triangle-down-yellow {
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-top: 30px solid #f7d72a;
}
.relative {
  position: relative;
}
.triangleSection {
  position: absolute;
  z-index: 11;
  width: 100%;
}

@media (max-width: 768px) {
  .carouselHeader {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  h2.carouselHeader {
    font-size: 1.8rem !important;
  }
}

@media (max-width: 430px) {
  h2.carouselHeader {
    font-size: 4vw !important;
  }
}
</style>
